import { useQuery } from "@tanstack/react-query";

import { getChangeLogs } from "../services/changeLogService";

const useChangeLogs = (entityName, fieldName, keys, take = 10, skip = 0) => useQuery({
    queryKey: ["change-logs", entityName, fieldName, keys],
    queryFn: () => getChangeLogs({ entityName, fieldName, keys, take, skip }).then(res => res.data)
});

export default useChangeLogs;